module.exports = __webpack_public_path__ + "static/media/tipo7.25df6db2.png";